// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.AppStore.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import { observable } from 'mobx';
import { isNil } from 'lodash/fp';
import AppGlobal from 'Izenda.AppGlobal';
import PerformanceStore from './Izenda.PerformanceStore';
import SecurityStore from './Izenda.SecurityStore';
import OtherSettingsStore from './Izenda.OtherSettingsStore';
import AccountStore from 'logic/Izenda.AccountStore';
import SecurityManager from 'share/authorization/Izenda.SecurityManager';
import LicenseInfoStore from './Izenda.LicenseInfoStore';
import ProvisionMapDataStore from 'logic/Izenda.ProvisionMapDataStore';
import SystemSettingsStore from './Izenda.SystemSettingsStore';

class AppStore {
  @observable hasSetupAndLicense = false;
  @observable licenseInfoStore = LicenseInfoStore;
  @observable provisionMapDataStore = ProvisionMapDataStore;
  @observable performanceStore = new PerformanceStore();
  @observable securityStore = new SecurityStore();
  @observable otherSettingsStore = new OtherSettingsStore();
  @observable accountStore = new AccountStore();
  @observable securityManager = new SecurityManager();
  @observable systemSettingsStore = new SystemSettingsStore();

  loadAppState() {
    const accessToken = this.securityManager.getAccessToken();
    if (!isNil(accessToken)) {
      this.loadAppSettings();
    }
  }

  /**
   * Load app setting data.
   */
  loadAppSettings() {
    return Promise.all([this.loadPerformance(), this.loadSecurity(), this.loadOther(), this.loadSystemSettings()]);
  }

  loadPerformance() {
    return this.performanceStore.loadPerformance().then(AppGlobal.setPerformance.bind(AppGlobal));
  }

  loadSecurity() {
    return this.securityStore.loadSecurity().then(AppGlobal.setSecurity.bind(AppGlobal));
  }

  loadOther() {
    return this.otherSettingsStore.loadOther().then(AppGlobal.setOther.bind(AppGlobal));
  }

  /**
   * Load System Settings
   */
  loadSystemSettings() {
    return this.systemSettingsStore.loadSystemSettings().then(AppGlobal.setSystemSettings.bind(AppGlobal));
  }

  /**
   * Load Category Settings
   */
  loadCategorySettings() {
    return this.systemSettingsStore.loadCategorySettings();
  }

  getProvisionMapDataStatus() {
    const accessToken = this.securityManager.getAccessToken();
    if (!isNil(accessToken)) {
      this.provisionMapDataStore.getProvisioningStatus();
    }
  }
}

const singleton = new AppStore();
export default singleton;



// WEBPACK FOOTER //
// ./ui/logic/Izenda.AppStore.js